import { DebtResponse } from "../../../types/debtType";
import { getApiHeaders, handleError } from "../../../utils/utils";
import API from "../../../api/api";

/**
 * Endpoint para obtener deudas de un usuario
 * @param rut rut del usuario sin puntos ni digito verificador
 */

const SEARCH_STEP = {
  //Endpoints para buscar deudas
  GET_DEBTS_TOKEN: `/payment-flow/search-step`,
  GET_DEBTS: (rut: string, recaptchaToken: string) =>
    `/payment-flow/search-step/${rut}?recaptchaToken=${recaptchaToken}`,
  GET_DEBTS_AUTH: (rut: string, recaptchaToken: string) =>
    `/payment-flow/search-step/auth/${rut}?recaptchaToken=${recaptchaToken}`,
};

/**
 * Obtiene las deudas asociadas a un usuario
 * @param rut sin puntos ni digito verificador
 */
export const requestGetDebts = async (
  rut: string,
  recaptchaToken: string,
  isLoggedIn?: boolean
) => {
  if (isLoggedIn) {
    const headers = getApiHeaders();
    const response = await API.get<DebtResponse & { fetchToken: string }>(
      SEARCH_STEP.GET_DEBTS_AUTH(rut, recaptchaToken),
      {
        headers,
      }
    );
    if (response?.data?.fetchToken) {
      localStorage.setItem("x-guest", response?.data?.fetchToken);
    }
    return response;
  } else {
    const response = await API.get<DebtResponse & { fetchToken: string }>(
      SEARCH_STEP.GET_DEBTS(rut, recaptchaToken)
    );
    if (response?.data?.fetchToken) {
      localStorage.setItem("x-guest", response?.data?.fetchToken);
    }
    return response;
  }
};

export const requestGetDebtsToken = async () => {
  try {
    const xGuestToken = localStorage.getItem("x-guest");
    return await API.get<DebtResponse>(SEARCH_STEP.GET_DEBTS_TOKEN, {
      headers: {
        "x-guest": xGuestToken,
      },
    });
  } catch (error: any) {
    handleError(error);
    throw error;
  }
};
